module.exports = __webpack_public_path__ + "static/media/google-g-logo.19cd5e01.svg";